import { Apis, Constants, Enums, Helpers, Store } from "utils";
import { IClinic, IService } from "interfaces";
import { PairValue } from "types";

export interface IServiceService {
  all(): Promise<any>;
  slice(offset?: number, count?: number): Promise<any>;
  findByClinic(clinicId: number): Promise<any>;
  findByClinicAndProvider(clinicId: number, providerId: number): Promise<any>;
}

export class ServiceService implements IServiceService {
  private qubehub: any;
  private controllerName: string = "service";

  constructor(accessToken: string) {
    this.qubehub = Apis.qubehub(accessToken);
  }

  /**
   * fetch all the user's services
   * @returns list of services
   */

  async all() {
    return await this.slice(0, Constants.MAX_INTEGER);
  }

  /**
   * fetch a slice of the user's services
   * @param {number} offset starting point for pagination purposes e.g. 10 it will get from appointment 10 - 10 + count
   * @param {number} count quatity of services to fetch e.g. 10 it will get 10 services starting point + 10
   * @returns list of services
   */

  async slice(offset: number = 0, count: number = Constants.PAGE_LENGTH): Promise<IService[]> {
    try {
      const [status, response] = this.#handleResponse(await this.qubehub.get(Helpers.toQueryString(this.controllerName, { offset, count })));
      return response ?? [];
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * fetch services by clinic
   * @param {number} clinicId clinic id
   * @returns {PairValue[]} list of services
   */

  async findByClinic(clinicId: number) {
    try {
      const [status, response] = this.#handleResponse(await this.qubehub.get(Helpers.interpolateURL(this.controllerName + "/clinic/:clinicId", { clinicId })));
      return response ?? [];
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * fetch services by clinic and provider
   * @param {number} clinicId clinic id
   * @param {number} providerId provider id
   * @returns {PairValue[]} list of services
   */

  async findByClinicAndProvider(clinicId: number, providerId: number) {
    try {
      const [status, response] = this.#handleResponse(
        await this.qubehub.get(Helpers.interpolateURL(this.controllerName + "/clinic/:clinicId/provider/:providerId", { clinicId, providerId }))
      );
      if (response) {
        return response.map((item: IClinic) => ({ key: item.clinicId, value: item.user?.username } as PairValue));
      }
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  /**
   * method to handle the response from the API
   * @param {any} response the data retrieved from the API
   * @returns
   */

  #handleResponse(response: any) {
    if (response && response.data) {
      const { status, payload } = response.data;
      if (Enums.EnumResponse.Unauthorized === status) Store.sessionStorage.clear();
      return payload ? [status, payload] : [status, null];
    }
    return [Enums.EnumResponse.None, null];
  }
}
